<template>
  <div v-if="networkError" class="network-alert" :class="{ 'offline': !isOnline }">
    <div class="alert alert-warning d-flex align-items-center" role="alert">
      <i class="fa-solid fa-wifi-slash me-2"></i>
      <div>
        {{ networkError }}
        <button v-if="!isOnline" @click="retryConnection" class="btn btn-sm btn-outline-warning ms-2">
          <i class="fa-solid fa-rotate me-1"></i> Réessayer
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import { defineComponent } from 'vue';

export default defineComponent({
  name: 'NetworkAlert',
  computed: {
    networkError() {
      return this.$store.getters.networkError;
    },
    isOnline() {
      return this.$store.getters.isOnline;
    }
  },
  methods: {
    retryConnection() {
      // Vérifier à nouveau l'état de la connexion
      this.$store.dispatch('checkNetworkStatus');
      
      // Si nous sommes en ligne, essayer de recharger les données
      if (this.isOnline) {
        this.$emit('retry');
      }
    }
  }
});
</script>

<style scoped>
.network-alert {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 9999;
  padding: 0.5rem;
  text-align: center;
  animation: slideDown 0.5s ease-in-out;
}

.offline .alert {
  background-color: #ffcc00;
  border-color: #e6b800;
  color: #664d00;
}

@keyframes slideDown {
  from {
    transform: translateY(-100%);
  }
  to {
    transform: translateY(0);
  }
}
</style>